import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { ClientAccessSettingsState } from '../ClientAccess.types';
import { selectCurrentClient } from '../../CommonSelectors/CommonAreaSelector';
import { useDispatch, useSelector } from 'react-redux';
import { refetchCurrentClient } from '../../AdviserArea/AdviserAreaActions';

export interface SaveClientAccessParams extends ClientAccessSettingsState {
  clientId: string;
}

const saveClientAccess = ({ clientId, ...params }: SaveClientAccessParams) => {
  const payload = {
    CurrentOnboardingWorkflow: params.onboardingWorkflow,
    DashboardAccessSet: params.dashboardAccess,
    LinkAccountsAccess: params.linkAccountsAccess,
    DataReconciliationAccess: params.dataReconciliationAccess,
    ClientLandingPage: params.clientLandingPage,
    IsProBonoClient: params.isProBonoClient,
    TaxableAccountModelGroup: params.taxableAccountModelGroup,
    NonTaxableAccountModelGroup: params.nonTaxableAccountModelGroup,
    FullyAutomatedAccountOpening: params.fullyAutomatedAccountOpening,
    SelectedAgreements: params.selectedAgreements,
    CanAddManualAccount: params.canAddManualAccount,
    DefaultDocumentUploadMobilePushNotifications:
      params.defaultDocumentUploadMobilePushNotifications,
    DefaultNewsfeedMobilePushNotifications: params.defaultNewsfeedMobilePushNotifications,
    AllowMobileAppPushNotifications: params.allowMobileAppPushNotifications,
  };

  return authFetch(urlWithParams('/Adviser/Adviser/ConfigureClientAccess', { clientId }), {
    method: 'POST',
    ...httpBodyOptions(payload, true),
  });
};

export const useSaveClientAccessMutation = () => {
  const { Id: clientId } = useSelector(selectCurrentClient);

  const dispatch = useDispatch();
  return useMutation(saveClientAccess, {
    async onSuccess() {
      await dispatch(refetchCurrentClient(clientId));
    },
  });
};
